import loader from "@core/Util/loader";
import api from "../api";
import {bootstrapDangerGrowl as errorGrowl} from "@core/Util/growler";

export default {
    methods: {
        cloneJourney(journeyId) {
            loader.show();

            api.cloneJourney(journeyId).then(
                ({id: newJourneyId}) => window.location.href = api.getViewJourneyUrl(newJourneyId),
                err => {
                    loader.hide();
                    errorGrowl(err);
                }
            )
        }
    }
}